import React, { useState } from "react";
import WarningIcon from "../../assets/icons/Icon_Library/application icons/assets/events/event_type_event-01.svg2";
import AlertIcon from "../../assets/icons/Icon_Library/application icons/assets/events/event_type_alert-01.svg2";
import NotificationIcon from "../../assets/icons/Icon_Library/application icons/assets/events/event_type_notification-01.svg2";
import EditIcon from "../../assets/icons/Icon_Library/application icons/assets/events/edit-01.svg2";
import EventDateIcon from "../../assets/icons/Icon_Library/application icons/assets/events/event_start_end_cal-.svg2";
import { Button, Col, Form, Row } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import ReactDatePicker from "react-datepicker";

export const eventTypes = [
  {
    value: "warning",
    label: "Warning",
    icon: WarningIcon,
    subText: "Pre-emptive & notification Inform",
    helpId: "eventType-warning",
  },
  {
    value: "alert",
    label: "Alert",
    icon: AlertIcon,
    subText: "Escalation of incident, critical, notifications",
    helpId: "eventType-alert",
  },
  {
    value: "notification",
    label: "Notification",
    icon: NotificationIcon,
    subText: "Information purposes bulletin's.",
    helpId: "eventType-notification",
  },
];

function EventType({ event, setEvent }) {
  const [selectType, setSelectType] = useState("");
  return (
    <>
      <Row className=" mt-2 ps-4 pe-4 m-2">
        <div className="ms-2">
          <div className="fw-bold my-3 p-0">Select type of event:</div>
          <div className="row row-cols-2 g-3">
            {eventTypes.map((c) => (
              <div className="col-12 col-sm-3" key={c.value}>
                <button
                  type="button"
                  className={`btn w-100 h-100 bg-white p-3 pt-4 rounded-3 position-relative  border border-2 ${
                    event?.Type === c.value ? "border-blue" : ""
                  }`}
                  onClick={() => {
                    setEvent({ ...event, Type: c.value });
                  }}
                >
                  {/* {selectType === c.value ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="position-absolute top-0 end-0 text-white bg-colored p-1"
                    style={{ borderBottomLeftRadius: 8 }}
                  />
                ) : null} */}{" "}
                  <div className="position-absolute top-0 start-0">
                    {c.helpId && <HelpButton helpKey={c.helpId} />}
                  </div>
                  <div className="d-flex align-items-start ms-3">
                    <div>
                      <MyIcon width={40} Icon={c.icon} className=" me-3" />
                    </div>
                    <div className="text-start">
                      <div className="fw-bold overflow-hidden">{c.label}</div>
                      <div className="text-secondary small">{c.subText}</div>
                    </div>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </Row>
      {event?.Type && (
        <Row className="py-3 mt-2 ps-4 pe-4 m-2">
          <Col className="col-5 border-end pe-4">
            <div className="row">
              <Col>
                <span className="fs-4 fw-bold">
                  Title & Description of the Event
                </span>
                <div className="text-secondary ">
                  Describe the event in detail, including any relevant
                  information or context.
                </div>
              </Col>
            </div>
            <div className=" my-3">
              <div>
                <Form.Group className="my-3" controlId="nameEvent">
                  <Form.Label className="fs-5 fw-bold">
                    Name of the Event:
                  </Form.Label>
                  <Form.Control
                    value={event?.Name}
                    onChange={(e) =>
                      setEvent({ ...event, Name: e.target.value })
                    }
                  />
                </Form.Group>
              </div>
              <div>
                <Form.Group className="my-3" controlId="referenceEvent">
                  <Form.Label className="fs-5 fw-bold">
                    Reference for this Event:
                  </Form.Label>
                  <Form.Control
                    value={event?.Reference}
                    onChange={(e) =>
                      setEvent({ ...event, Reference: e.target.value })
                    }
                  />
                </Form.Group>
              </div>

              <div>
                <Form.Group className="my-3" controlId="descriptionEvent">
                  <Form.Label className="fs-5 fw-bold">
                    Description / notes of the Events:
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={event.Description}
                    onChange={(e) =>
                      setEvent({ ...event, Description: e.target.value })
                    }
                  />
                </Form.Group>
              </div>
            </div>
          </Col>

          <Col className="col-7 ps-4">
            <span className="fs-4 fw-bold">Date time of event:</span>
            <div className="text-secondary">
              Choose the start and end date/time for the event.
            </div>
            <div className="mt-3">
              <Button className="px-2 p-2 border-0 bg-white fw-bold text-nowrap w-100 d-flex justify-content-between align-items-center">
                <EventDateIcon width={20} className=" me-2" />
                <div className="text-navy w-25 text-start">STARTS:</div>
                <div className="flex-grow-1">
                  <ReactDatePicker
                    placeholderText="Start now or select date & time"
                    isClearable
                    selected={
                      event?.StartedAt ? new Date(event.StartedAt) : null
                    }
                    onChange={(date) => {
                      setEvent({ ...event, StartedAt: date?.toISOString() });
                    }}
                    showTimeSelect
                    dateFormat="dd-MM-yyyy HH:mm"
                    className="form-control"
                    maxDate={event?.EndedAt ? new Date(event.EndedAt) : null}
                  />
                </div>
                <div>
                  <EditIcon width={20} className=" ms-3" />
                </div>
              </Button>
            </div>
            {/* <div className=" mt-3 d-flex justify-content-end">
              <div>
                <Button className="bg-colored-reverse px-2 p-2 border-0 btn-sm fw-bold text-nowrap">
                  Add on End Date/Time
                  <AddIcon width={20} className="text-white ms-3" />
                </Button>
              </div>
            </div> */}
            <div className="mt-3">
              <Button className="px-2 p-2 border-0 bg-white fw-bold text-nowrap w-100 d-flex justify-content-between align-items-center">
                <EventDateIcon width={20} className=" me-2" />
                <div className="text-navy w-25 text-start">ENDS:</div>
                <div className="flex-grow-1">
                  <ReactDatePicker
                    placeholderText="Select for end date & time (optional)"
                    isClearable
                    selected={event?.EndedAt ? new Date(event.EndedAt) : null}
                    onChange={(date) => {
                      setEvent({ ...event, EndedAt: date?.toISOString() });
                    }}
                    showTimeSelect
                    dateFormat="dd-MM-yyyy HH:mm"
                    className="form-control"
                    minDate={
                      event?.StartedAt ? new Date(event.StartedAt) : null
                    }
                  />
                </div>
                <div>
                  <EditIcon width={20} className=" ms-3" />
                </div>
              </Button>
            </div>
            <div className="my-4">
              <div className="fw-bold fs-4">Alert Level:</div>
              <div
                className="rounded-pill p-2 fw-bold  d-flex justify-content-between text-white my-3"
                style={{
                  background: `linear-gradient(
                                        90deg,
                                        rgba(30, 250, 0, 1),
                                        rgb(255, 187, 0),
                                        rgba(255, 0, 0, 1) 
                                        )`,
                }}
              >
                <button
                  type="button"
                  className="ms-2 btn text-white fw-bold"
                  onClick={() => {
                    setEvent({
                      ...event,
                      Severity: "low",
                    });
                  }}
                >
                  LOW{" "}
                </button>
                <button
                  type="button"
                  className="ms-2 btn text-white fw-bold "
                  onClick={() => {
                    setEvent({
                      ...event,
                      Severity: "medium",
                    });
                  }}
                >
                  MEDIUM{" "}
                </button>
                <button
                  type="button"
                  className="ms-2 btn text-white fw-bold"
                  onClick={() => {
                    setEvent({
                      ...event,
                      Severity: "high",
                    });
                  }}
                >
                  HIGH
                </button>
                <button
                  type="button"
                  className="ms-2 btn text-white fw-bold"
                  onClick={() => {
                    setEvent({
                      ...event,
                      Severity: "critical",
                    });
                  }}
                >
                  CRITICAL
                </button>
              </div>
              <div>
                <input
                  type="range"
                  className="w-100"
                  step={1}
                  min={0}
                  max={3}
                  value={["low", "medium", "high", "critical"].indexOf(
                    event?.Severity || "low"
                  )}
                  onChange={(e) => {
                    setEvent({
                      ...event,
                      Severity: ["low", "medium", "high", "critical"][
                        parseInt(e.target.value)
                      ],
                    });
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
}

export default EventType;
